var map = {
	"./annotation.js": 6261,
	"./auth.js": 8467,
	"./elements.js": 8229,
	"./files.js": 9709,
	"./index.js": 4642,
	"./navigation.js": 1346,
	"./notifications.js": 4701,
	"./process.js": 6653,
	"./selection.js": 3804,
	"./tree.js": 7551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6806;